import * as types from './actionTypes';

export function toggleNavBar() {
	return {
		type: types.NAV_BAR_TOGGLE,
	};
}

export function closeNavBar() {
	return {
		type: types.NAV_BAR_CLOSE
	};
}

export function transitionComplete() {
	return {
		type: types.NAV_BAR_TRANSITIONED
	};
}

export function showSelectStoreModal() {
	return {
		type: types.SHOW_SELECT_STORE_MODAL
	};
}

export function hideSelectStoreModal() {
	return {
		type: types.HIDE_SELECT_STORE_MODAL
	};
}

export function showChangePasswordModal() {
	return {
		type: types.SHOW_CHANGE_PASSWORD_MODAL
	};
}

export function hideChangePasswordModal() {
	return {
		type: types.HIDE_CHANGE_PASSWORD_MODAL
	};
}

export function hideErrorModal() {
	return {
		type: types.HIDE_ERROR_MODAL
	};
}


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/actions.js
 **/